// extracted by mini-css-extract-plugin
export default {"icon":"Manuales_icon__LaVSW"};